import { BaseJsonSchema, createSchemaByBasicTypes } from "../../helpers";

export const IFvpOutstreamOptions: BaseJsonSchema = {
  type: "object",
  properties: {
    type: createSchemaByBasicTypes("string", "outstream"),
    width: createSchemaByBasicTypes("number"),
    height: createSchemaByBasicTypes("number"),
    waitForScroll: {
      description:
        "Waits for window scroll event before initializing the player. Set as boolean to enable for all devices, or set as object to enable for specific devices [desktop, mobile]. Defaults to false.",
      anyOf: [
        {
          type: "object",
          properties: {
            desktop: createSchemaByBasicTypes("boolean"),
            mobile: createSchemaByBasicTypes("boolean"),
          },
        },
        {
          type: "boolean",
        },
      ],
    },
    placement: {
      type: "object",
      properties: {
        desktop: {
          type: "object",
          properties: {
            bottom: createSchemaByBasicTypes("number"),
            left: createSchemaByBasicTypes("number"),
            right: createSchemaByBasicTypes("number"),
            top: createSchemaByBasicTypes("number"),
          },
        },
        mobile: {
          type: "object",
          properties: {
            bottom: createSchemaByBasicTypes("number"),
            left: createSchemaByBasicTypes("number"),
            right: createSchemaByBasicTypes("number"),
            top: createSchemaByBasicTypes("number"),
          },
        },
      },
    },
  },
  additionalProperties: false,
};
